module.exports = __webpack_public_path__ + "img/SEJ_Eventos_escanear_white.f2cb4a77.svg";